import { render, staticRenderFns } from "./EditorInputModal.vue?vue&type=template&id=6544d567&"
import script from "./EditorInputModal.vue?vue&type=script&lang=js&"
export * from "./EditorInputModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports